export default __webpack_public_path__ + "static/media/performance.4369aed9.svg";